import { useRef } from "react";
import { Upload, X, FileText } from "lucide-react";

export function FilePicker({ label, files, onChange, testId, required = false }) {
  const inputRef = useRef();

  const addFiles = (e) => {
    onChange([...files, ...Array.from(e.target.files || [])]);
    e.target.value = "";
  };

  return (
    <div>
      <p className="text-sm font-medium text-slate-700 mb-1.5">
        {label} {required && <span className="text-red-500">*</span>}
      </p>
      <div className="flex flex-wrap gap-2">
        {files.map((f, i) => (
          <div key={i} className="relative flex items-center gap-1.5 rounded border border-slate-200 bg-slate-50 px-2 py-1.5 max-w-[220px]">
            <FileText className="h-3.5 w-3.5 text-slate-400 shrink-0" />
            <span className="truncate text-xs text-slate-700">{f.name}</span>
            <button
              type="button"
              data-testid={`${testId}-remove-${i}`}
              onClick={() => onChange(files.filter((_, j) => j !== i))}
              className="ml-auto text-slate-400 hover:text-red-600"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
        <button
          type="button"
          data-testid={testId}
          onClick={() => inputRef.current?.click()}
          className="flex items-center gap-1.5 rounded border-2 border-dashed border-slate-300 px-3 py-1.5 text-xs text-slate-400 hover:border-amber-500 hover:text-amber-600 transition-colors"
        >
          <Upload className="h-3.5 w-3.5" /> Add files
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*,.pdf,.heic,.webp" multiple hidden onChange={addFiles} />
    </div>
  );
}
